/**
 * Expands a URL template with parameters.
 * @param {string} template - The URL template with placeholders like {key} for required params and {&key1,key2} for optional query params.
 * @param {object} params - An object containing key-value pairs for the parameters.
 * @returns {string} The expanded URL.
 */
export function expandUrl(template, params) {
    // Replace required parameters {key}
    let url = template.replace(/\{(\w+)\}/g, (match, key) => {
        if (params[key] !== undefined) {
            return encodeURIComponent(params[key]);
        } else {
            // If required param is missing, leave the placeholder as is or handle error
            // For now, assuming required params are always provided
            return match;
        }
    });

    // Replace optional parameters {&key1,key2}
    url = url.replace(/\{\&([^}]+)\}/g, (match, keysStr) => {
        const keys = keysStr.split(',');
        let query = '';
        keys.forEach(key => {
            if (params[key] !== undefined) {
                query += `&${key}=${encodeURIComponent(params[key])}`;
            }
        });
        return query;
    });

    return url;
}